<template>
  <b-modal
    v-model="showModal"
    size="md"
    hide-footer
    centered
    header-class="ApplicationEditModalHeaderVariant"
    header-text-variant="white"
    :no-close-on-backdrop="true"
    :title="title"
  >
    <template v-slot:default>
      <div>
        <!-- 検索部 -->
        <div class="WorkM_ConstructionList">
          <!-- リスト部 -->
          <div class="WorkM_SubstituteWorkTable">
            <div v-for="workInfoItem in workInfoList" :key="workInfoItem.detailNo">
              <div class="WorkInfoItem my-1" :class="!isAttendanceCheck(workInfoItem.workSegment) ? 'text-danger' : ''" @click="selectSubstitude(workInfoItem)">
                <!-- 時間 -->
                <div
                  class="WorkInfoItem_WorkTimeArea"
                  :class="!isAttendanceCheck(workInfoItem.workSegment) ? 'WorkInfoItem_WorkTimeArea_Red' : ''"
                >
                  <div>{{ workInfoItem.startTime }}</div>
                  <div>{{ workInfoItem.endTime }}</div>
                </div>
                <!-- 内容 -->
                <div class="WorkInfoItem_WorkContentArea">
                  <div class="WorkContent_ItemTypeArea">
                    <div style="min-width:130px" class="WorkContent_ConstructionName">{{ getStrDateSlash(workInfoItem.workDate) + "(" + getDayOfWeek(workInfoItem.workDate) + ")" }}</div>
                    <div v-if="workInfoItem.constructionCode != 0">
                      <div v-if="workInfoItem.disasterKbn == 1" class="WorkContent_ConstructionName text-danger ml-2">災害</div>
                    </div>
                  </div>
                  <div class="mt-1">
                    <div v-if="workInfoItem.constructionCode == 0">
                      <div v-if="workInfoItem.disasterKbn == 1" class="WorkContent_ConstructionName text-danger">災害</div>
                    </div>
                    <div class="d-flex">
                      <div style="min-width:70px;" v-if="workInfoItem.constructionCode != 0" class="WorkContent_ConstructionCode">[{{ workInfoItem.constructionCode }}]</div>
                      <div style="max-height: 27px; overflow:hidden; text-overflow: ellipsis" v-if="workInfoItem.constructionName !== null" class="WorkContent_ConstructionName">{{ workInfoItem.constructionName }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import config from "../../const/config";
export default {
    props: {
        title: { type: String, default: "振出選択" },
        message: { type: String, default: "" },
        loginUserId: { type: Number, default: 0 },
    },
    data: function(){
        return{
            showModal: false,
            radioTarget: "0",
            optionConstructionCode: [], 
            optionConstructionCodeWithKeyword: [],
            optionConstructionCodeWithoutKeyword: [],
            selectConstructionCode: 0,
            constructionKeyword: "",
            workInfoList: [],
        }
    },
    computed: {},
    mounted: function () {
        this.optionConstructionCode = [];
    },
    methods: {
      openModal: function () {
        console.log("open SelectSubstituteWorkModal");
        this.getSubstituteListInfo();
        this.selectConstructionCode = 0;
        this.radioTarget = "0";
        this.showModal = true;
      },
      selectSubstitude: function(item){
        console.debug(item);
        if(item == null){
          this.showAlertError("振出を選択してください。");
          return;
        }
        else {
          let setSubstituteWork = {
            detailNo:item.detailNo,
            date:item.workDate,
            start:item.startTime,
            end:item.endTime,
            time:item.workTime,
          }
          this.$emit("setSubstituteWork", setSubstituteWork)
          this.showModal = false;
          this.$emit("handleOk");
        }
      },
      // 出勤チェック
      isAttendanceCheck: function(workSegment){
        if(workSegment != 1 && workSegment != 11 && workSegment != 12 && workSegment != 21 && workSegment != 22 && workSegment > 0){
          return false;
        }
        else{
          return true;
        }
      },
      // 区分コードに合わせた区分名を返す
      getDispSegment: function (segmentCd) {
        let optionSegment = config.OPTIONS.WORK_SEGMENT;
        let result = "";
        optionSegment.forEach((element) => {
          if (element.value == segmentCd) {
            result = element.text;
          }
        });
        return result;
      },
      // APIから振休一覧と振出一覧の情報を取得
      getSubstituteListInfo: function(){
        console.log("loginUserId：" + this.loginUserId);
        let paramList = {
            shainCd: this.loginUserId
        }
        console.debug(JSON.stringify(paramList));
        this.getWithParams(config.URL.USER_INFO_TRANSFER_WORK_LIST, paramList)
          .then((response) => {
            if(response.result){
              console.debug("response：" + JSON.stringify(response.container));
              this.isErrorGetShfitFlg = false;
              this.setSubstituteListInfo(response.container);
            }
            else{
              this.isErrorGetShfitFlg = true;
              this.showAlertError(response.message);
            }
          })
          .catch((e) => {
            // Note: エラーメッセージは、共通処理で表示している
            console.error(e);
          })
          .finally(() => {});

      },
      // TODO:取得した一覧情報をそれぞれの一覧にセット
      setSubstituteListInfo: function(items){
        this.workInfoList = items.workInfoList;
      },
    }
};
</script>
<style>
.WorkM_InputGroup_ItemLabel {
  font-size: 0.85rem;
  color: rgb(13, 91, 136);
  font-weight: 700;
  margin: 0;
}
.WorkM_InputTimeGroup {
  display: flex;
}
.WorkM_InputTimeGroup_InputItem {
  width: 4rem;
}
.EditModalHeaderVariant {
  background-color: rgb(13, 91, 136);
}
.WorkM_ConstructionList{
    min-height:415px;
}
.WorkM_ConstructionItems{
    background: rgb(248, 248, 248);
    border-radius: 5px;
    height: 2rem;
}
.WorkM_ConstructionSelectItems{
    background: #007bff;
    color: #fff;
    border-radius: 5px;
    height: 2rem;
}
.WorkM_ConstructionKeyword{
    height:81px;
}
.WorkM_SubstituteWorkTable{
    width:100%;
    max-height:655px;
    overflow-y: auto;
}
.SearchWorkInfoItem {
    line-height: 1rem;
}
.ApplicationEditModalHeaderVariant {
  background-color:rgb(128, 00, 128);
}
</style>